export default __webpack_public_path__ + "static/media/sunsculpted9.f0dba984.jpg";